export const CS_CENTER_SECTION = {
  NOTICE: 'NOTICE',
  FAQ: 'FAQ',
  ONE_TO_ONE: 'ONE_TO_ONE',
};

export const FAQ_LIST = [
  {
    query: '셔틀버스는 어디에서 타나요?',
    answer: `제주공항 도착 후 렌트카 셔틀버스 탑승장으로 이동★8구역3번 승차장★에서 제주로렌트카 셔틀 탑승
    방법-->5번 게이트 앞 횡단보도를 3번 건너서, 렌트카하우스 방향으로 가다 보면, 그 전에 좌측에 8구역이 있습니다.바닥에 번호 3번에서 대기하시면 됩니다.
    (10분~15분 간격 순환 운행, 이동 시간 10분이내)

    카카오톡 하단 챗봇에 보다 다양한 정보가 있으니 참고바랍니다.
    공항(본사행)에서는 07:45 첫 차 출발하며, 21:45분 막 차 출발합니다. 
    본사(공항행)에서는 06:30 첫 차 출발하며, 20:00분 막 차 출발합니다.

    [셔틀운행시간]
    ★본사 출발 셔틀 06:30~20:00
      공항 출발 셔틀 07:45~21:45
    (08~20시까지 10분~15분 간격 순환 운행)
    새벽 본사 출발 시간: 06:30, 07:00, 07:30
    야간 공항 출발 시간: 20:15, 20:45, 21:15, 21:45
    본사에서 공항으로 가는 마지막 셔틀버스는 20시입니다. 20시 이후에는 개별적으로 이동하셔야 합니다.

    ★마지막 셔틀을 탑승하지 못할 경우 개별적으로 본사로 이동하셔야 합니다.
    (22시까지 인수가 어려울 경우 익일 인수) -> 비행기 지연일 경우에도 동일 적용
  `,
  },
  {
    query: '예약을 완료했는데 이후에 절차가 어떻게 되나요?',
    answer: `홈페이지로 예약을 완료 후 카드결재 또는 가상계좌 입금을 하시면 예약이 확정됩니다.
    별도의 전화 예약 확인 전화는 드리지 않습니다.
    예약 확인은 홈페이지 우측 상단에 ‘예약확인’ 탭을 통해서 해주시기 바랍니다. 예약자 성함과 전화번호를 입력하면 예약을 확인하실 수 있습니다. 
    렌트카 이용에 관한 안내는 고객님께서 오시기 하루 전날 당사에서 카카오톡 채널을 통하여 제주에 도착 시 셔틀버스를 탑승하는 방법 및 렌트카 이용시 반드시 알아야 할 계약내용, 그리고 특약선택에 대한 내용, 운전자 사전등록 링크 등을 보내드립니다.
    당사에서 보내드리는 카카오톡을 읽어보시면 어렵지 않게 오셔서 렌트가 가능합니다.
    또한 업무시간 내에는 카카오톡을 통하여 상담해 드리오니 언제든지 활용바랍니다.
    `,
  },
  {
    query: '왜 제주로렌트카이어야 할까?',
    answer: `다음과 같은 이유로 많은 고겍님들이 제주로렌트카를 이용하고 계십니다.

1) 공항과의 거리
반납 1분차이로 비행기를 놓칠 수 있습니다!
→ 제주로렌트카 - 공항 5분 ~ 10분거리! 고급 대형 버스 10~15분 간격으로 순환운행

2) 셔틀 버스
코로나 시국에 미워터지는 카니발은 그만!
→ 우등형 대형 셔틀버스 10~15분 간격으로 순환운행!

3) 빠른 인수
인수 1분차이로 맛집 웨이팅이 차이납니다!
→ 키오스크로 1분 인수! 제주도 키오스크 무인체크인 최초도입

4) 자체 정비소 여부
렌트카는 반납 후 무조건적인 정비가 필요합니다!
→ 자체 정비소 운영!

5) 직판 렌트카
모든 문제 해결을 빠르게 할 수 있고 중간 유통과정을 거치지 않아 저렴한 가격에 이용 가능합니다!
→ 100% 직판 렌트카 (총 1000대 보유)

6) 인수/반납의 자유
새벽비행기, 저녁 늦게 도착하는 비행기에도 렌트카 인수반납  가능!
→ 새벽반납, 야간인수 가능/ 배차비 0원

7) 다양한 차종보유
경차에서 고급차, 오픈카, 슈퍼카(포르쉐, 벤츠 G바겐)까지 모두 보유
→ 제주도에서 선택의 폭이 가장 넓은 렌트카회사, 최대 차종 보유 렌트카회사

8) 카카오채널 추가시 5% 할인
 비용부담은 줄이고!
→ 카카오톡 채널 추가 시 5% 할인코드 자동 발송

9) 무거운 아기 카시트와 유모차 무료로 딜리버리
아기와 함께 하는 여행, 무거운 카시트와 유모차는 당시 제휴업체에서!
→ 꾸러기유모차(064-745-9996)에서 제휴 가격으로 저렴하게, 딜리버리 서비스까지

이러한 이유로 선택은 제주로렌트카
    `,
  },
  {
    query: '렌트카 예약을 했는데 전화 연락이 오나요?',
    answer: `렌트카 예약를 완료하시면 별도의 전화는 드리지 않습니다.
렌트카 이용에 대한 내용은 고객님들에게 렌트카 대여시작 하루 전날 셔틀버스 안내/ 주요계약내용 안내/ 운전면허증 사전등록안내등을 카카오톡을 통해 안내해 드리고 있습니다. 
궁금하신 사항이 있으실 경우 카카오톡 상담을 통해 문의주시면 자세히 안내해 드리고 있습니다.(업무시간내)`,
  },
  {
    query: '카카오톡 채널추가는 어떻게 하나요?',
    answer: `제주로렌트카 홈화면 우측 하단의 카카오톡2 아이콘을 누르시면 추가됩니다. 
제주여행 시 카카오톡을 통해 더욱 더 자세한 상담이 가능하오니 채널추가 부탁드립니다. 
    `,
  },
  {
    query: '제2운전자를 어떻게 추가등록하나요?',
    answer: `렌트카 운전은 제1운전자와, 제2운전자 총 2명이 가능합니다. 제1운전자는 필히 자국 면허증을 소지하신 분들만 등록이 가능합니다. 
제1운전자는 사전체크인 링크를 통해 등록가능하고, 키오스크에서 체크인 할 때, 등록이 가능합니다. 
제2운전자는 사전체크인 또는 키오스크에서 체크인 할 때 등록이 가능하고, 대여한 후에 추가하려면 사전체크인 링크를 통해 운전자의 인적사항과, 전화번호, 면허번호를 입력하신 후, 개인정보동의 등이 절차를 거친 후 서명을 하시면 자동으로 운전자추가등록이 됩니다.
운전자는 총 2명까지만 등록이 가능하며 더이상의 추가 또는 변경이 불가합니다. 
또한 타인의 면허증을 이용한 차량대여는 불법이며 형사처벌받으실 수 있음을 알려드립니다.
    `,
  },
  {
    query: '면허증 실물이 없는데 사전체크인을 어떻게 하나요?',
    answer: `면허번호 정보를 알 수 있는경우 사전체크인란에 면허정보 입력후 신분증 사진을 올려주시면 됩니다.
면허정보를 모를경우 본인명의 휴대폰의 경우 182를 통해 본인의 면허정보를 알수 있습니다.
단, 업무시간에만 가능하오니 참고바랍니다.  
업무시간 이외의 경우 제주공항 도착후 1층 자치경찰단을 방문후 신분증 제시후 면허정보를 받으실 수 있으나 업무시간 이외에만 가능하다는 점 알려드립니다. 
    `,
  },
  {
    query: '사전체크인이 무엇인가요?',
    answer: `제주로렌트카는 제주지역 최초로 고객님들의 대여시간을 단축하고 비대면시대에 발맞춰 키오스크를 이용한 대여계약을 시행하고 있습니다.
대여시작일 하루전날 렌트카대여계약내용에 대해 카카오톡을 통해 안내해드리고 있으며 보다 빠른 대여계약을 위해 오시기 전에 미리 고객님들의 운전면허증을 등록하실 수 있도록 링크를 보내드리고 있습니다. 
해당 링크에 들어가 운전면허증을 등록하는 행위를 사전체크인이라합니다. 사전체크인을 하시면 본사 도착후 30초만에 대여계약을 체결하고 즐거운 제주여행을 시작하실 수 있습니다.
다음 동영상을 참고하시면 쉽게 하실 수 있습니다.
https://www.youtube.com/watch?v=ALOF6-xNE48 
또한 제주로렌트카 카카오톡 채널에보시면 여러가지 정보가 많이 있으니 참고바랍니다.
    `,
  },
  {
    query: '취소 수수료는 어떻게 되나요?',
    answer: `예약변경 및 취소방법
★ 변경은 업무시간에만 가능합니다. 
★ 업무시간 외 변경은 불가능하오니 충분히 숙고하시어 예약진행 부탁드립니다.
★ 사용당일자의 모든 변경사항은 해당 렌트카업체의 기준에 준하며 해당업체에 문의바랍니다.
★ 렌트카 조기반납 시, 남은 일정에대한 차량료 및 보험료는 환불이 불가합니다.

예약 취소 시 환불(렌트카 이용일자 기준)
고객님의 렌트카 예약취소는 기간에 따라서 취소수수료가 부과될 수 있습니다.
취소 시 환불규정
  취소수수료안내:
(인수일 기준)이용 4일전- 취소수수료 없음.
이용 3일전 취소시 총 이용 요금의 10% 수수료 발생
이용 2일전 취소시 총 이용 요금의 30% 수수료 발생
이용 1일전 취소시 총 이용 요금의 50% 수수료 발생
당일 취소시 총 이용 요금의 100% 전액 환불불가

2025년 성수기 취소수수료 규정
- 삼일절 연휴(2/27~3/3)
- 근로자/어린이날/부처님오신날 연휴 (5/1~5/6)
- 현충일 연휴(6/5~6/8)
- 여름성수기(7/24~8/10)
- 광복절 연휴 (8/14~8/17)
- 개천절, 한글날, 추석 연휴(10/1~10/12)
- 12월 성탄 및 연말연휴(12/24~26년1/1)

이용 5일전 취소시 총 이용 요금의 10% 수수료 발생
이용 4일전 취소시 총 이용 요금의 20% 수수료 발생
이용 3일전 취소시 총 이용 요금의 30% 수수료 발생
이용 2일전 취소시 총 이용 요금의 40% 수수료 발생
이용 1일전 취소시 총 이용 요금의 50% 수수료 발생
당일 취소시 총 이용 요금의 100% 전액 환불불가 

취소 시에는 규정에 따라 수수료가 발생되오니
이 점 유의하시기 바라며 예약 시 신중히 검토 후 진행하실 것을 부탁드립니다.
[ 단, 천재지변(항공 및 선박 결항)의 경우는 전액 환불처리 가능합니다. ]
[ 결항 예상으로 임의 취소후, 취소된 예약건은 다시 사용할수 없으며 새예약을 통해 이용이 가능합니다. ]
    `,
  },
  {
    query: '유모차/카시트를 빌릴 수 있나요?',
    answer: `유모차,카시트 문의는 아래 업체로 연락바랍니다..
[꾸러기 유모차]

064-745-9996

사전 설치 딜리버리 가능
당사 입점업체`,
  },
  {
    query: `차량 인수/반납 시간이 어떻게 되나요?`,
    answer: `[인수 반납 가능시간]             
인수가능시간: 08:00~22:00
반납가능시간: 06:00~20:00

★새벽 및 야간 배차비 안내★
새벽 06:00~07:30 반납비용 1만원
야간 22까지 배차이용 0원
야간 22시 이후 배차 불가

  [셔틀운행시간]
★본사 출발 셔틀 06:30~20:00
  공항 출발 셔틀 07:45~21:45
(08~20시까지 10분~15분 간격 순환 운행)
새벽 본사 출발 시간: 06:30, 07:00, 07:30
야간 공항 출발 시간: 20:15, 20:45, 21:15, 21:45
본사에서 공항으로 가는 마지막 셔틀버스는 20시입니다. 20시 이후에는 개별적으로 이동하셔야합니다.

★마지막 셔틀을 탑승하지 못할 경우 개별적으로 본사로 이동하셔야 합니다.
(22시까지 인수가 어려울 경우 익일 인수) -> 비행기 지연일 경우에도 동일 적용`,
  },
  {
    query: '본사외의 장소에서 차량을 인수할 수 있나요?',
    answer: `제주도의 렌트카 경우, 공항에서 인수/반납이 불가합니다. 또한 당사에서는 본사에서 차량 인수/반납을 원칙으로 하고 있습니다.`,
  },
  {
    query: '네비게이션은 무료인가요?',
    answer: `네비게이션은 전차종 무료로 제공되고 있습니다. 다만, 운행중 네비게이션의 이상으로 차량교환이나 환불을 요청하실 수는 없습니다.`,
  },
  {
    query: '차량을 렌트하는데 자격이나 조건이 있나요?',
    answer: `저희 렌트카를 이용하기 위해서는 반드시 다음의 조건을 충족시키셔야 합니다.
연령은 만26세 이상이어야 하며, 운전면허를 취득한지 1년이상이 되야 합니다.(면허취득 1년이상이시더라도 장롱면허는 해당되지 않습니다.)
단, 승합, 수입 일부 차량의 경우만 30세 이상이어야 합니다.`,
  },
  {
    query: `자차면책제도가 무엇인가요?`,
    answer: `기본적으로 렌트카 예약시 대인/대물/자손보험은 가입되어 있으나 자기차량에 대한 면책은 고객님의 선택사항이며 , 결제는 현장에서 렌트카 인수시 직접 결제하면 됩니다.
자차면책제도란 자기차 손해에 대한 면책을 뜻하며, 일종의 보험과 비슷하다고 보시면 됩니다.
내 실수 또는 쌍방간의 사고로 내 차가 부서졌을 경우 수리비에 대해 면책을 받는 것으로 보통 상대방 부주의로
사고가 났다해도 쌍방과실이 적용되니 가입해두는 것이 좋습니다.
선택사항으로 차량인수시 가입여부 결정 후 계약서를 작성하시면 됩니다.

자기차량면책제도 가입과 미가입시 사고처리의 예
LF소나타 차량 렌트중 신호없는 교차로에서 다른 차량과 충돌로 과실이 5:5로 나왔으며 내차에 대한 수리비가 총 200만원이 나왔으며 차량수리기간은 10일이 소요되는 경우를 가정해보자.
1. 자차면책 미가입시
자차 수리비 200만원 전액과 휴차보상료(수리기간동안 영업하지 못한 손실에 대한 보상)( LF소나타하루 대여료의 50%(150,000/2=75,000원)수리기간 10일) 750,000원, 총 2,750,000원을 부담하셔야 합니다.

2.일반면책가입시
수리비의 20%(최저30만~최고50만) = 면책금 30만원과 휴차보상료 750,000원 총 1,050,000원을 부담하셔야 합니다.

3.고급면책가입시
수리비 + 휴차보상료가 한도금액(LF소나타의 경우 300만원)을 넘지 않았으므로 고객 부담은 없습니다. 

단, 상대방 차량을 수리하기 위해 대물 접수를 할 경우, 상대방 차량 보험 접수에 따른 대물면책금 30만원이 발생합니다. 사고로 인하여 사람이 다쳤을 경우, 대인 접수를 해야하는데, 해당 대인 접수 면책금도 30만원입니다. 즉, 대인과 대물 보험 접수 면책금은 각 각 30만원입니다. 
다음의 경우는 보험처리 및 차량손해(자차) 면책처리가 불가능합니다.

1) 임차인의 고의로 인한 사고
2) 무면허 운전사고
3) 음주운전, 약물중독운전 사고 - 렌트카를 경기용이나 연습용, 테스트용으로 사용하던 중 발생한 사고
4) 임차인(임차인과 기록된 공동임차인 포함) 이외의 제3자가 렌트카를 사용하여 발생한 사고
5) 본인 부주의로 인한 차량도난사고
6) 정원초과로 인한 사고
7) 사고 후 당사 미보고 사고
8) 1사고 1건 초과 사고
9) 우도내에서 발생하는 모든 사고.
10) 타이어펑크 및 타이어파손 비용, 사고견인, 현장출동(배터리방전,키분실 등)비용은 자차에 적용되지 않습니다. (고객부담)
11) 11대중과실
12) 단독사고 면책금발생(30~50만원)
`,
  },
  {
    query: '대인 또는 대물 면책금 30만원은 무엇인가요?',
    answer: `자차면책에 가입하였어도, 상대방 차량을 수리하기 위해서는 대물 면책금 30만원이 발생합니다. 차대인 사고가 났을 경우에도 대인접수를 하기 위해서는 대인 면책금 30만원이 발생합니다. 
단, 상대방 차량을 수리하기 위해 대물 접수를 할 경우, 상대방 차량 보험 접수에 따른 대물면책금 30만원이 발생합니다. 사고로 인하여 사람이 다쳤을 경우, 대인 접수를 해야하는데, 해당 대인 접수 면책금도 30만원입니다. 즉, 대인과 대물 보험 접수 면책금은 각 각 30만원입니다. `,
  },
  {
    query: '면허증을 분실했는데 재발급 받을 시간이 없어요.',
    answer: `렌터카를 이용하는데에 면허증은 필수입니다.
만일 부득이하게 면허증을 분실하셨을 경우 다음과 같은 방법으로 준비해주시면 됩니다.
1) 가까운 경찰서에 가셔서 어떤 용도로 이용하는지 말씀하시고 "경력증명서' 를 발급받으시거나, 인터넷 http://www.dla.go.kr/(운전면허 관리단)에서 경력증명서 발급을 하시면 되십니다. 발급받은 경력증명서를 렌트카 계약서 작성시 제시해 주시면 운전면허증이 없이도 계약이 가능합니다. 제주공항 도착전 미리 발급 받고 오셔야 차량인수시간을 줄일 수 있습니다.

2) 사전에 준비를 못하셨을 경우, 제주공항 1층에 위치한 자치경찰대에서 발급이 가능하십니다(제주로렌트카 친구추가하시면 가시는길이 동영상으로 자세히 안내되어 있습니다.) 

3) 마지막으로(평일에만 이용가능가능합니다.) 경찰민원상담 TEL : 182 ARS로 넘어가면 순서 3번 누르시고 --> 1번 --> 주민번호 13자리 입력하라고 안내해드립니다.
상담원분하고 통화하면서 필요한 정보 제공을 알려주시면- 1종:면허번호, 적성검사기간- 2종: 면허번호, 면허증갱신기간 통화로 알려주고 문자로 요청하시면 본인 휴대폰 번호에 문자로 알려줍니다. 안내받으신 문자를 임대차 계약시 보여주시면 됩니다. `,
  },
  {
    query: '쓰레기 반입 비용 5000원은 어떤것인가요?',
    answer: `▶차량내, 쓰레기 반입 비용 
★5000원★

▶반납 시 차량에 반입되는 음식물, 음료수, 기저귀 등 악취를 유발하는 쓰레기로 인해,환기를 시켜도 냄새가 빠지지 않는 경우가 발생하고 있습니다. 그리고 이에 따른 고객님들의 클레임이 지속적으로 올라오고 있어 불가피하게 청구하게 되었습니다. 
양해 부탁드립니다^^

쓰레기 처리비용은 반납시 차량내 쓰레기가 남아있을 경우에만 청구됩니다.
반납전 차량내 쓰레기를 모두 처리하신 후 반납하시면 따로 청구되는 비용은 없습니다.
고객님들에게 보다 쾌적하고 차량을 제공해드리기 위함이니 고객님들의 많은 협조바랍니다.`,
  },
  {
    query: '색상은 어떻게 결정이 되나요?',
    answer: `차량 색상은 따로 지정할 수 없으며, 랜덤으로 배정됩니다.`,
  },
  {
    query: `전기차를 처음으로 이용하는데, 어떻게 사용하나요?`,
    answer: `▶코나/아이오닉5/EV6/EV3 : DC콤보.

▶전기차 충전안내:
개인 신용카드를 사용하여 충전해주시기 바랍니다. 반납시에는 출고 시 충전된 양만큼 채워주시기 바랍니다. 초과로 충전한 부분에 대해서는 환불이 불가합니다.

▶부족분에 대하여 코나전기차는 1칸당 3,000원, 아이오닉 및 EV6는 10% 3,000원 비용이 청구됩니다.

▶테슬라 모델3 사용방법
당사에서는 고객님들의 편의를 위해 DC콤보용 어뎁터를 무상로 제공하고 있습니다. 충전비는 고객님의 신용카드로 결재바랍니다. 반납시에는 출고 시 충전된 양만큼 맞춰서 반납해주시기 바라며, 부족분에 대해서는 10%에 4,000원 청구됩니다.

▶DC콤보용 어뎁터 분실시 20만원이 청구
DC콤보용 어뎁터 사용방법:
https://youtu.be/gPjyuoBpamo
슈퍼차저이용: 중문 롯데호텔 및 제주시 테슬라 지점에 설치된 슈퍼차저 이용 시 충전료는 반납시 결재해주시면 됩니다.

충전소 정보는 하단을 참고해주세요.
https://blog.naver.com/jejurotravel/223124392367 (충전소 "EV인프라" 어플 사용방법)

https://www.ev.or.kr/evmonitor (웹으로 보여지는 충전소 위치)
필터: 충전타입(DC콤보 또는 AC3상)/운영기관(환경부)
필터를 꼭 선택해주시기바랍니다.
전기차 충전 콜센터(24시간 운영)(1899-8852)`,
  },
  {
    query: '타이어공기압 경고등이 떴어요(겨울철)',
    answer: `일단 차량을 안전한 갓길에 정차후 육안으로 타이어 상태를 살핍니다. 현저하게 바람이 빠진 바퀴가 있다면 당사로 전화해주시길 바랍니다 .육안으로 아무런 이상이 없는경우 다음과 같은 현상일 수 있습니다.
겨울철이 다가오면 기온이 내려가고 외부 기압이 오르면서, 타이어 공기압이 줄어드는 현상이 발생합니다. 그래서 겨울이 되면 자동차 계기판에 타이어 공기압 경고등이 많이 켜집니다.
경고등이 작동되더라도 운행하시는데에 지장은 없으나 혹시 불안하시면 가까운 정비소(각 자동차 메이커사 정비코너)에 들러 공기압 점검을 요청하시면 됩니다. 감사합니다. 편안한 여행되세요`,
  },
  {
    query: '차량 주행하다가 사고가 났어요.',
    answer: `차량을 운행하다가, 사고가 났을 경우 즉시 당사(064-744-1116 내선4번)으로 연락 주시기 바랍니다. (고급자차에 가입하였어도 당사로 보고가 안된 사고에 대해서는 보험 적용이 불가합니다.) 
직원의 안내에 따라 사고 경위를 말씀해주시고 아래와 같은 양식으로 사고 사진을 보내주세요.
-사고 현장의 전체적인 모습이 보이도록 찍어주세요.
-상대차량의 번호판이 보이게 사진을 찍어주시고, 고객님이 운행중이신 차량 또한 번호판이 보이게 정면에서 사진을 찍어서 보내주세요.
-접촉 부위가 잘 보이게 가까이서 사진을 한 번 찍어주시고, 약간 거리를 두고 정확한 사고부위 확인이 가능하도록 찍어서 보내주세요.

보험처리를 위하여 상대방 차량의 번호와 운전자의 연락처, 상대방 보험사와 보험접수 번호가 필요합니다. 

자기차량면책제도 가입과 미가입시 사고처리의 예
LF소나타 차량 렌트중 신호없는 교차로에서 다른 차량과 충돌로 과실이 5:5로 나왔으며 내차에 대한 수리비가 총 200만원이 나왔으며 차량수리기간은 10일이 소요되는 경우를 가정해보자.
1. 자차면책 미가입시
자차 수리비 200만원의 50%에 해당하는 100만원 수리비와 휴차보상료(수리기간동안 영업하지 못한 손실에 대한 보상)( LF소나타하루 대여료의 50%(150,000/2=75,000원)수리기간 10일) 750,000원, 총 1,750,000원을 부담하셔야 합니다.

2.일반면책가입시
수리비의 20%(최저10만~최고50만) = 면책금 20만원과 휴차보상료 750,000원 총 950,000원을 부담하셔야 합니다.

3.고급면책가입시
수리비가 한도금액(LF소나타의 경우 300만원)을 넘지 않았으므로 고객 부담은 없습니다. 

단, 상대방 차량을 수리하기 위해 대물 접수를 할 경우, 상대방 차량 보험 접수에 따른 대물면책금 30만원이 발생합니다. 사고로 인하여 사람이 다쳤을 경우, 대인 접수를 해야하는데, 해당 대인 접수 면책금도 30만원입니다. 즉, 대인과 대물 보험 접수 면책금은 각 30만원입니다. 

다음의 경우는 보험처리 및 차량손해(자차) 면책처리가 불가능합니다.
1) 임차인의 고의로 인한 사고
2) 무면허 운전사고
3) 음주운전, 약물중독운전 사고 - 렌트카를 경기용이나 연습용, 테스트용으로 사용하던 중 발생한 사고
4) 임차인(임차인과 기록된 공동임차인 포함) 이외의 제3자가 렌트카를 사용하여 발생한 사고
5) 본인 부주의로 인한 차량도난사고
6) 정원초과로 인한 사고
7) 사고 후 당사 미보고 사고
8) 1사고 1건 초과 사고
9) 우도내에서 발생하는 모든 사고.
10) 타이어펑크 및 타이어파손 비용, 사고견인, 현장출동(배터리방전,키분실 등)비용은 자차에 적용되지 않습니다. (고객부담)
11) 11대중과실
12) 단독사고 면책금 발생(30~50만원)`,
  },
  {
    query: '단독사고는 어떻게 처리 되나요?',
    answer: `
단독사고의 경우, 한도 내에서 면책금 30만원(수입차/쏠라티는 50만원)이 발생합니다. 한도를 초과할 경우, 해당 비용은 고객님 부담입니다.

단독사고가 났을 경우, 본사로 즉시 보고를 해주시기 바랍니다. 직원에 요청에 따라 사고경위와 사진을 보내주시기 바랍니다.

사진을 아래와 같은 방법으로 촬영하여 보내주세요.
- 차량 번호판과 정면의 모습이 전부 보이게 촬영후 보내주세요.
- 사고 부위를 가까이서 촬영하여 보내주세요.
- 정확한 사고부위를 확인하기 위하여 약간 거리를 두고 사고부위와 차량의 모습이 보이게 촬영후 보내주세요.`,
  },
  {
    query: '렌트카 차량 인수 또는 반납은 어디서 하나요?',
    answer: `
렌트카 차량 인수와 반납은 모두 본사에서 이루어집니다. 

제주공항 도착후 렌트카셔틀버스 탑승장 이동★8구역3번 승차장★에서 제주로렌트카 셔틀 탑승
-->5번 게이트 앞 횡단보도를 3번 건너서, 렌트카하우스 방향으로 가다 보면, 그 전에 좌측에 8구역이 있습니다.바닥에 번호 3번에서 대기하시면됩니다.

공항과 본사간 거리는 약3킬로미터 정도이며 이동소요시간은 약 10분~15분 정도입니다. 
본사에 도착하시면 예약하신 차량이 준비되어 있으며 키오스크를 통해 무인으로 계약서 작성 후 여행을 시작하시면 됩니다.
당사에서는 차량인수 예정일 전에 문자메세지를 통해 인수장소를 안내해드리고 있습니다.

주차장에서 차량상태 및 연료확인 후 인수(차량인수 시 사진 촬영은 필수)해주시길 바랍니다. 
반납은 원칙상 본사반납만 가능합니다. 반납시 꼭 당사 주소를 이용하여 찾아와 주세요
본사주소 : 제주시 오일장중길 128(제주시 도두이동 1106)
    `,
  },
  {
    query: '자차보상한도 무제한 및 현장출동 특약은 무엇인가요?',
    answer: `특약상품1: 현장출동특약상품(자차제외항목특약)
비용: 3일에 1만원
차량 장금해제
배터리 방전 무료
타이어 펑크 및 스크래치 무료
휠 파손 및 스크래치 무료
사고 및 타이어 파스로 인한 견인 무료(기본 10KM에 한해 무료)

특약상품2: 보상한도 무제한 특약 & 현장출동특약
비용: 1일 1만원
일반자차, 고급자차를 가입한 고객에 한해 보상한도 무제한 및 현장출동 특약 무료

자차보상한도 무제한 및 현장출동 특약상품은 모두 1회성 소멸상품입니다.`,
  },
  {
    query: '주한미군 / 외국인도 차량 렌트할 수 있나요?',
    answer: `
    자국 면허증을 소지한 외국인은 차량 렌트 가능합니다. 
국제 면허증을 소지한 외국인은, 제2운전자로만 등록이 가능하며, 제1운전자는 필히 자국 면허증을 소지한 분으로 등록해야합니다. 
외국인 : 제네바 협약,비엔나 협약, SOFA 가입국에서 발행한 국제운전면허증과 개인여권소지자
※ 외국인의 경우 제1운전자 등록 불가
※ 차량 대여 기준 연령 및 운전 경력은 운전면허증 정보에 준합니다.
※ 실 운전자 포함 제2운전자까지 등록 가능합니다.

주한미군 - 개인여권과 오렌지카드(주한미군 운전면허증) / 여권이 없거나, 영문 철자가 여권과 틀린 경우, 코팅 된 오렌지카드(주한미군 운전면허증)는 렌트 불가함.

※ 주의사항 : 국제면허증과 여권 - 국제운전면허증은 International Driving Permit 만 가능 / 영문 철자가 틀린 경우, 이름이 풀네임으로 표기되지 않은 경우(풀네임 확인 어려운 경우)는 렌트 불가함. `,
  },
  {
    query: '예약자와 운전자가 달라요',
    answer: `예약자와 운전자가 다른 경우 인수 전날 보내드리는 사전체크인 링크에 접속 후 예약자로 예약을 검색한 후 실제 운전하실 분으로 운전자로 변경 후 실제로 운전하실 분의 인적사항 및 면허정보를 입력하시면 됩니다.`,
  },
  {
    query:
      '(주)제주유명렌트카, (주)갤럭시렌트카 로 예약을 했는데 제주로렌트카로 예약이 되었어요.',
    answer: `제주로렌트카는 (주)제주유명렌트카, (주)갤럭시렌트카, (주)하나로렌트카, (주)그린렌트카 업체가 공동운영하고 있습니다. 
규모의 대형화를 통해 서비스의 질을 강화하고 고객님들께 보다 양질의 차량을 제공하기위해 노력하고 있습니다.  
공항셔틀버스 대형화, 슈퍼카(벤츠, 포르쉐)보유, 다양한 수입오픈카 도입,  무인키오스크도입(제주도내 최초) 등 공동운영을 통해 점점 더 발전하고 있는 제주로렌트카입니다. 앞으로도 고객님들의 보다 나은 제주여행을 위해 고민하고 또 고민하겠습니다.`,
  },
  {
    query: '반려동물 탑승가능한가요?',
    answer: `애견동반금지입니다.`,
  },
];
export const NOTICE_LIST = [
  {
    title: '차종 변경 수수료에 대한 안내',
    date: '2023-07-04',
    detail: `차종변경에 대한 변경 수수료 안내입니다. (변경에 대한 문의는 예약실로 문의해주시기 바랍니다.)

초기 예약한 차종에 따라 등급별로 수수료 발생합니다. (신규 예약하고자하는 차종 상관없음)
차량 렌트 요금 차액은 별도로 청구됩니다. 

경차/ 소형  :  20,000원 
준중형/중형:  30,000원
고급/SUV   :  40,000원
수입/승합   : 50,000원 
슈퍼카       : 불가 (24시간 금액 청구)

차종 변경에 대해서 위 수수료는 기본적으로 발생되고 차량 렌트 요금의 차액은 추가로 청구됩니다. 

위 수수료는 차량 출고전 기준 금액으로, 차량 출고 후 변경에 대한 문의는 수수료도 상이하고 렌트카 상황에 따라 달라지므로 별도로 문의해주시기 바랍니다. 
    `,
  },
  {
    title: '제주로렌트카 셔틀버스 운행시간 및 탑승장소 안내',
    date: '2023-01-13',
    detail: `안녕하세요. 

제주로렌트카 셔틀버스 운행시간 및 탑승 장소에 대해 설명드리겠습니다. 

제주공항 1층 5번게이트로 나오셔서 횡단보도를 두 번 건넌 후 렌트카하우스 좌측
★8구역3번 승차장★에서 제주로렌트카 셔틀 탑승.
[셔틀운행시간]
★본사 출발 셔틀 06:30~20:00
     공항 출발 셔틀 07:45~21:45
(08~20시까지 10분~15분 간격 순환 운행)
새벽 본사 출발 시간: 06:30, 07:00, 07:30
야간 공항 출발 시간: 20:15, 20:45, 21:15, 21:45
본사에서 공항으로 가는 마지막 셔틀버스는 20시입니다. 20시 이후에는 개별적으로 이동하셔야합니다.

 ★마지막 셔틀을 탑승하지 못할 경우 개별적으로 본사로 이동하셔야 합니다.

 [인수 반납 가능시간]
인수가능시간: 08:00~22:00
반납가능시간: 06:00~20:00

★새벽 및 야간 배차비 안내★
새벽 06:00~07:30 반납비용 1만원
야간 배차비용 0원
야간 22:00~ 배차불가
      `,
  },
  {
    title: '렌트카 이용 시간 변경 안내',
    date: '2022-10-13',
    detail: `★인수 반납 가능시간★
인수가능시간: 08:00~22:00
반납가능시간: 06:00~20:00

★새벽 및 야간 배차비 안내★
새벽 06:00~07:30 반납비용 1만원
야간  배차비용 0원
야간 22:00~ 배차불가

[셔틀운행시간]
★본사 출발 셔틀 06:30~20:00
   공항 출발 셔틀 07:45~21:45
(08~20시까지 10분~15분 간격 순환 운행)
새벽 본사 출발 시간: 06:30, 07:00, 07:30
야간 공항 출발 시간: 20:15, 20:45, 21:15, 21:45
본사에서 공항으로 가는 마지막 셔틀버스는 20시입니다. 20시 이후에는 개별적으로 이동하셔야합니다.

 ★마지막 셔틀을 탑승하지 못할 경우 개별적으로 본사로 이동하셔야 하며, 비행기 지연도착의 경우에도 동일합니다.
비행기 연착으로 인하여 부득이하게 22시까지 인수가 어려우실 경우에는 익일 인수하시기 바랍니다.

★운전면허증 필수 지참★
★전차량 금연차★ 
    `,
  },
];
